import React from 'react';
import PropTypes from 'prop-types';

import PriceSliderFilter from './PriceSliderFilter';
import DatePickerFilter from './DatePickerFilter';
import RentalTypeFilters from './RentalTypeFilters';

const BaseFilters = props => {
  const classNameToUse = props.simpleFilters ? 'search-simple-filters' : '';
  const {
    onHandleToggleCheckbox,
    isValueChecked,
    filters,
    renderInfoToolTip
  } = props;

  return (
    <div className={classNameToUse}>
      <DatePickerFilter
        from={props.filters['move-in']}
        flexibleMoveIn={props.filters.flexibleMoveIn}
        flexibleMoveOut={props.filters.flexibleMoveOut}
        minimumStaying={props.minimumStaying}
        to={props.filters['move-out']}
        updateFiltersWith={props.updateFiltersWith}
        disablePrice={props.disablePrice}
      />
      <RentalTypeFilters
        onHandleToggleCheckbox={onHandleToggleCheckbox}
        isValueChecked={isValueChecked}
        rentalFilter={filters['rentalType[]']}
        renderInfoToolTip={renderInfoToolTip}
      />
      <PriceSliderFilter
        budget={props.filters.budget}
        currency={props.currency}
        maxPriceInCity={props.maxPriceInCity}
        unitPrices={props.unitPrices}
        updateFiltersWith={props.updateFiltersWith}
        disablePrice={props.disablePrice}
      />
    </div>
  );
};

BaseFilters.propTypes = {
  simpleFilters: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  updateFiltersWith: PropTypes.func.isRequired,
  currency: PropTypes.object.isRequired,
  unitPrices: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  maxPriceInCity: PropTypes.number.isRequired,
  minimumStaying: PropTypes.number.isRequired,
  onHandleToggleCheckbox: PropTypes.func.isRequired,
  isValueChecked: PropTypes.func.isRequired,
  renderInfoToolTip: PropTypes.func,
  disablePrice: PropTypes.bool
};

BaseFilters.defaultProps = {
  renderInfoToolTip: () => {},
  disablePrice: false
};

export default BaseFilters;
